// extracted by mini-css-extract-plugin
export default {"Navbar":"Navbar_Navbar__dJeqW","Navbar__Links":"Navbar_Navbar__Links__MH6os","Wrapper":"Navbar_Wrapper__h-lmO"};